import { LoaderCircle } from "lucide-react";
import { useEffect, useRef } from "react";

export function InfiniteScrollTrigger({ hasMore, loading, onLoadMore }: {
  hasMore: boolean; loading: boolean; onLoadMore: () => void;
}) {
  const target = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = target.current;
    if (!element || !hasMore) return;
    const observer = new IntersectionObserver((entries) => {
      if (entries[0]?.isIntersecting && !loading) onLoadMore();
    }, { rootMargin: "500px 0px" });
    observer.observe(element);
    return () => observer.disconnect();
  }, [hasMore, loading, onLoadMore]);
  return <div ref={target} className="flex min-h-16 items-center justify-center py-4" aria-live="polite">
    {loading && <span className="flex items-center gap-2 text-sm font-bold text-ink/45"><LoaderCircle className="animate-spin" size={18} />Loading more…</span>}
    {!loading && hasMore && <span className="sr-only">More items load as you scroll.</span>}
  </div>;
}
